import React from "react";
import { Link } from "react-router-dom";
import { formatPackagePrice, weekdayPartyPackages } from "../data/packages";
import { PRICE_DISCLOSURE } from "../data/bookingPolicies";
import PrivatePartyPackages from "../components/PrivatePartyPackages";
import Icon from "../components/Icon";

export default function Packages() {
  const weekdayPrice = Math.min(
    ...weekdayPartyPackages.map((pkg) => pkg.price),
  );
  return (
    <div className="packages-section">
      <PrivatePartyPackages
        context="home"
        headingId="home-private-party-title"
      />
      <div className="package-comparison-link">
        <Link className="text-link" to="/packagesdetail">
          Compare all party options <Icon />
        </Link>
      </div>
      <div className="weekday-callout">
        <div>
          <p className="eyebrow">A SMALLER WEEKDAY GET-TOGETHER?</p>
          <h3>Non-private parties, from {formatPackagePrice(weekdayPrice)}.</h3>
          <p>Monday–Thursday only. {PRICE_DISCLOSURE}.</p>
        </div>
        <Link
          className="button button-secondary"
          to="/packagesdetail#weekday-parties"
        >
          Explore weekday parties <Icon />
        </Link>
      </div>
    </div>
  );
}
